//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RedAPI from '@/api/promotores/red.api'
export default {
	data() {
		return {
			red: [],
			loading: false
		}
	},

	mounted() {
		this.loadRed()
	},

	methods: {
		async loadRed() {
			try {
				this.loading = true
				this.red = await RedAPI.all()
			} finally {
				this.loading = false
			}
		},
		clickInvitado(invitado) {
			this.$router.push({ name: 'promotor', params: { promotor: invitado.id } })
		}
	}
}
